<button type="button" (click)="readAccessMedia()" class="btn btn-success" attr.aria-label="{{ 'ACCESS_MEDIA.READ_ACCESS_MEDIA.BUTTON' | translate }}">{{ 'ACCESS_MEDIA.READ_ACCESS_MEDIA.BUTTON' | translate }}</button>
